import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { AppInjector } from "../injectors";

export class TranslationModel {
    key: string;
    translation: string;
}

export class TranslationLanguagesModel {
    selectedLanguage: string;
    languages: TranslationLanguageModel[];
}

export class TranslationLanguageModel {
    culture: string;
    name: string;
    cultureFront:string;
    cultureNumber:string;
    decimalSeparator:string;
    thousandSeparator:string;
}

export class TranslationManager {

    static languages: TranslationLanguagesModel;
    static translations: any[] = [];

    static init(): Promise<void> {
        return new Promise((resolve, reject) => {

            let storedCulture = localStorage.getItem('esourcing-translation-culture');

            storedCulture = storedCulture ? storedCulture.trim() : '';

            if (!TranslationManager.languages) {
                TranslationManager.languages = new TranslationLanguagesModel();
            }

            TranslationManager.languages.selectedLanguage = storedCulture;

            TranslationManager.getLanguages().then(() => {

                localStorage.setItem('esourcing-translation-culture', TranslationManager.languages.selectedLanguage);
                localStorage.setItem('esourcing-translation-culture-number', TranslationManager.languages.languages.find(q=>q.culture===storedCulture).cultureNumber);

                TranslationManager.getTranslations().then(() => {
                    resolve();
                }).catch((e: any) => {
                    reject(e);
                })
            }).catch((e: any) => {
                reject(e);
            })
        });
    }

    static getLanguages(): Promise<void> {
        return new Promise((resolve, reject) => {
            let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
            httpClient.get(`${environment.apiUrl}/Translations/Languages`).toPromise().then((item: TranslationLanguagesModel) => {
                TranslationManager.languages = item;
                resolve();
            }).catch((e: any) => {
                reject(e);
            })
        });
    }

    static getTranslations(): Promise<void> {
        return new Promise((resolve, reject) => {
            let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
            httpClient.get(`${environment.apiUrl}/Translations/Translations`).toPromise().then((items: TranslationModel[]) => {

                if (items) {
                    items.forEach(s => {
                        TranslationManager.translations[s.key] = s.translation;
                    })
                }

                resolve();
            }).catch((e: any) => {
                reject(e);
            })
        });
    }

    static setLanguage(culture: string) {
        localStorage.setItem('esourcing-translation-culture', culture);
        TranslationManager.init();
    }

    static getTranslationCultureFromStore() {

    }

    static getTranslation(key: string): string {
        let item = TranslationManager.translations[key];

        if (!item) {
            TranslationManager.translations[key] = '-';
        }

        return TranslationManager.translations[key];
    }
}
